import React, { useMemo, useState } from 'react';
import { Button, Typography, Box, Grid, TextField } from '@mui/material';
import BasicModal from './CongratsModal'
import { useForm } from 'react-hook-form';
import * as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup";

type OrderFormData = {
    arrivalTime: string;
    arrivalDate: string;
}

type OrderFormField = {
    name: keyof OrderFormData;
    label: string;
    type: 'time' | 'date';
    required: boolean;
    gridSize: number;
}

let schema = Yup.object({
    arrivalTime: Yup.string().required(),
    arrivalDate: Yup.string().required()
});

const formFields: OrderFormField[] = [
    {
        name: 'arrivalTime',
        label: 'الوقت لوصول الطلب',
        type: 'time',
        required: true,
        gridSize: 4
    },
    {
        name: 'arrivalDate',
        label: 'اليوم لوصول الطلب',
        type: 'date',
        required: true,
        gridSize: 4
    }
];

const OrderForm = ({ transcribe }: { transcribe: string }) => {
    const {
        register,
        handleSubmit,
        formState: { errors } } = useForm<OrderFormData>({
            defaultValues: {
                arrivalTime: '',
                arrivalDate: ''
            },
            resolver: yupResolver(schema)
        })
    const [open, setOpen] = useState(false)

    const onSubmit = (data: OrderFormData) => {
        console.log(data)
        setOpen(true)
    };

    const renderField = (field: OrderFormField) => {
        const commonProps = {
            label: field.label,
            required: field.required,
            fullWidth: true,
            error: !!errors[field.name],
            helperText: errors[field.name]?.message,
            ...register(field.name),
            InputLabelProps: {
                sx: { textAlign: 'right', direction: 'rtl' }
            }
        };

        return (
            <TextField
                {...commonProps}
                type={field.type}
                component={'div'}
                focused
                inputProps={{
                    min: field.type === 'date' ? new Date().toISOString().split('T')[0] : undefined,
                    max: field.type === 'date' ? new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0] : undefined
                }}
            />
        );
    };

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h4" gutterBottom component={'div'}>
                    أدخل البيانات الخاصة بتوصيل الطلب اليك
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }} justifyContent={'center'} display={'flex'}>
                    {formFields.map(field => (
                        <Grid item xs={field.gridSize} key={field.name}>
                            {renderField(field)}
                        </Grid>
                    ))}
                </Grid>

                <Button
                    variant="contained"
                    color="primary"
                    type='submit'
                    disabled={transcribe.length === 0}
                    sx={{ mb: 2 }}
                >
                    Submit
                </Button>
            </form>
            <BasicModal open={open} handleClose={() => {
                setOpen(false);
                window.location.reload()
            }} />
        </Box>
    );
};

export default OrderForm;
